import Dialog from "../../../../components/dialog/Dialog";
import DialogButton from "../../../../components/dialog/DialogButton";
import AlertTriangleIcon from "../../../../components/icons/AlertTriangleIcon";
import styles from "./rolesPermissions.module.css";

const DeleteRoleDialog = ({ roleName, busy, error, onConfirm, onClose }) => {
  const close = () => {
    if (!busy) onClose();
  };

  return (
    <Dialog
      title="حذف الدور"
      icon={<AlertTriangleIcon />}
      tone="danger"
      size="sm"
      role="alertdialog"
      onClose={close}
      closeOnEscape={!busy}
      closeOnBackdrop={!busy}
      footer={
        <>
          <DialogButton variant="secondary" onClick={close} disabled={busy}>
            إلغاء
          </DialogButton>
          <DialogButton variant="danger" onClick={onConfirm} disabled={busy}>
            {busy ? "جارٍ الحذف…" : "حذف"}
          </DialogButton>
        </>
      }
    >
      <div className={styles.dialogBody}>
        <p className={styles.dialogText}>
          سيُحذف الدور <bdi className={styles.dialogRoleName}>{roleName}</bdi>{" "}
          نهائياً، ويُزال من «يمكنه تعيين» في الأدوار الأخرى.
        </p>
        {error && <p className={styles.dialogError}>{error}</p>}
      </div>
    </Dialog>
  );
};

export default DeleteRoleDialog;
